import { memo } from "react";

/**
 * مراسم الزوار — الشعار الرسمي (PNG 400×400 RGBA أصلي).
 * Simple, spec-compliant rendering. NO cropping, NO borders, NO opacity,
 * NO overflow hidden. object-fit: contain preserves the full mark.
 *
 * Variants (fixed sizes per user spec):
 *   - "full"  : 180×180 — Login/Hero
 *   - "mark"  : 56×56   — TopBar / small
 *   - "brand" : 56×56 mark + inline arabic/english text stack (TopBar)
 *   - "large" : 240×240 — About Hero (single spot)
 */
const LOGO_SRC = "/logo-gold.png";

const BASE_STYLE = {
  objectFit: "contain",
  objectPosition: "center",
  display: "block",
  background: "transparent",
  border: "none",
  outline: "none",
  padding: 0,
  margin: 0,
  imageRendering: "-webkit-optimize-contrast",
};

function BareLogo({ size, alt = "مراسم الزوار", className = "", ...rest }) {
  const px = `${size}px`;
  return (
    <img
      src={LOGO_SRC}
      alt={alt}
      width={size}
      height={size}
      loading="eager"
      fetchPriority="high"
      decoding="async"
      draggable="false"
      className={`logo-image ${className}`}
      style={{ ...BASE_STYLE, width: px, height: px }}
      {...rest}
    />
  );
}

function LogoBrand({ className = "" }) {
  // TopBar: 56×56 mark + inline text label
  return (
    <div className={`inline-flex items-center gap-3 ${className}`}>
      <BareLogo size={56} />
      <div className="text-right leading-tight hidden sm:block">
        <div className="text-primary font-bold text-base md:text-lg tracking-wide">مراسم الزوار</div>
        <div className="text-white/40 text-[9px] tracking-[0.3em] uppercase">MARASIM ALZUWAR</div>
      </div>
    </div>
  );
}

const Logo = memo(function Logo({ variant = "brand", size, className = "", ...rest }) {
  if (variant === "full") return <BareLogo size={size ?? 180} className={className} {...rest} />;
  if (variant === "large") return <BareLogo size={size ?? 240} className={className} {...rest} />;
  if (variant === "mark") return <BareLogo size={size ?? 56} className={className} {...rest} />;
  return <LogoBrand className={className} />;
});

export default Logo;
